module.exports = __webpack_public_path__ + "img/Avatar-17.c65d5abd.gif";